import React, { useContext } from 'react';
import { ControlPanelContext } from '../../data/control-panel-context/ControlPanelConf';
import { getConfiguration } from '../../data/utils';
import { getLabel } from '../../data/labels';

function ControlPanel(props) {
	const conf = getConfiguration();
	const controlPanelContext = useContext(ControlPanelContext);
	
	return(
	<div className="widget-ultimi bg-bianco bordo-tondo margine-giu widget-betslip">
        <div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
            <span><i className="fas fa-circle"></i> {getLabel('carrello.control_panel')}</span>
        </div>
        <div className="contenuto-widget-ultime-v bordato-widget">
            <div className="control-panel-functions">
                {
                	conf.ste && <>
	                	<div onClick={() => controlPanelContext.toggleTicketBox()} className="cp-function-row">
		                	<span className="cp-ico">
		                		<i className="fas fa-print"></i>
		                	</span>	
		                	<span className="cp-label">{getLabel('carrello.print_tickets')}</span>	
	                	</div>
	                   <div className="separationRow"></div>
                	</>
                }

                
                <div onClick={() => controlPanelContext.togglePrintSettingsBox()} className="cp-function-row">
            		<span className="cp-ico">
            			<i className="fas fa-tools"></i>
            		</span>	
            		<span className="cp-label">{getLabel('carrello.print_settings')}</span>	
                </div>
            </div>
        </div>
    </div>
	);
}

export default ControlPanel;